export type DemandaStatus =
  | 'ABERTA'
  | 'EM_ANALISE'
  | 'AGUARDANDO_CLIENTE'
  | 'RESOLVIDA'
  | 'CANCELADA';

export type DemandaTipo = 'FINANCEIRO' | 'COMERCIAL' | 'SUPORTE' | 'OFICINA';

export type DemandaPrioridade = 'BAIXA' | 'MEDIA' | 'ALTA';

export type Demanda = {
  id: string;
  protocolo: string;
  titulo: string;
  descricao: string;
  status: DemandaStatus;
  prioridade: DemandaPrioridade;
  tipo: DemandaTipo;
  categoria?: string | null;
  companyId: string;
  conversationId?: string | null;
  solicitanteActorType?: 'CLIENTE' | 'OFICINA_STAFF' | 'PORTAL_USER' | string;
  solicitanteActorId?: string;
  solicitanteNome?: string | null;
  solicitanteEmail?: string | null;
  createdAt: string;
  updatedAt?: string;
  company?: { id: string; name: string };
  assignee?: { id: string; name: string; email: string } | null;
  conversation?: {
    id: string;
    mode: string;
    status: string;
    title?: string;
    operatorUnreadCount?: number;
    lastUserMessageAt?: string | null;
  } | null;
  hasAttachment?: boolean;
  hasAudio?: boolean;
};

export type DemandaClienteResumo =
  | { available: false; reason?: string }
  | {
      available: true;
      cliente: { id: string; nome: string; placa: string | null };
      veiculo: {
        placa: string | null;
        marca: string | null;
        modelo: string | null;
        ano: string | null;
        cor: string | null;
      };
      contrato: {
        numero: string | null;
        inicio: string | null;
        fimEsperado: string | null;
        status: string | null;
        progressoPct: number | null;
      };
      financeiro: {
        titulosAbertos: number;
        titulosVencidos: number;
        titulosPagos: number;
        saldoAberto: number;
        valorPago: number;
      };
      oficina: {
        quantidadeOs: number;
        ultimaOsEm: string | null;
      };
    };

export type ChatMsg = {
  id: string;
  role: string;
  content: string;
  createdAt: string;
  attachmentUrl?: string | null;
  attachmentName?: string | null;
  attachmentMime?: string | null;
  attachmentSize?: number | null;
  metadata?: { kind?: string; transcricao?: string | null } | null;
  /** true se o destinatário leu (cliente ou operador, conforme o papel). */
  readByPeer?: boolean | null;
};

export type PortalConversation = {
  id: string;
  title: string;
  mode: string;
  status: string;
  companyId: string;
  actorType: string;
  actorId: string;
  updatedAt: string;
  operatorUnreadCount?: number;
  lastUserMessageAt?: string | null;
  company?: { id: string; name: string };
  demandas?: Array<{ id: string; protocolo: string; status: string }>;
};

export const STATUS_OPTS: DemandaStatus[] = [
  'ABERTA',
  'EM_ANALISE',
  'AGUARDANDO_CLIENTE',
  'RESOLVIDA',
  'CANCELADA',
];

export const STATUS_LABELS: Record<DemandaStatus, string> = {
  ABERTA: 'Aberta',
  EM_ANALISE: 'Em análise',
  AGUARDANDO_CLIENTE: 'Aguardando cliente',
  RESOLVIDA: 'Resolvida',
  CANCELADA: 'Cancelada',
};

export const TIPO_OPTS: DemandaTipo[] = ['FINANCEIRO', 'COMERCIAL', 'SUPORTE', 'OFICINA'];

export const TIPO_LABELS: Record<DemandaTipo, string> = {
  FINANCEIRO: 'Financeiro',
  COMERCIAL: 'Comercial',
  SUPORTE: 'Suporte',
  OFICINA: 'Oficina',
};

export function statusVariant(
  s: string
): 'default' | 'success' | 'warning' | 'danger' | 'info' {
  if (s === 'RESOLVIDA') return 'success';
  if (s === 'CANCELADA') return 'danger';
  if (s === 'EM_ANALISE') return 'warning';
  if (s === 'AGUARDANDO_CLIENTE') return 'info';
  return 'default';
}

export function tipoVariant(
  t: string
): 'default' | 'success' | 'warning' | 'danger' | 'info' | 'secondary' {
  if (t === 'FINANCEIRO') return 'success';
  if (t === 'COMERCIAL') return 'info';
  if (t === 'OFICINA') return 'warning';
  return 'secondary';
}
